import { keyframes } from '@chakra-ui/react';

const transform = keyframes`
  from { opacity: 1 }
  to { opacity: 0 }
`;

export const fadeOut = (speed = '2s', delay = '2s'): string =>
  `${transform} ${speed} forwards ${delay}`;
